import { Autocomplete, Box, Checkbox, Chip, TextField, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { useSupervisorSelection } from './useSupervisorSelection';

export const SupervisorsSelection = () => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const {
    selectedSupervisors,
    handleRemoveSupervisor,
    supervisors,
    supervisorInputValue,
    lastTypedSupervisorValue,
    setSupervisorInputValue,
    handleAddSupervisor,
    isSupervisorsLoading,
  } = useSupervisorSelection();
  return (
    <Box id="supervisors-selection">
      <Box sx={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1) }}>
        <Typography variant="h6" sx={{ mb: theme.spacing(4) }}>
          {formatMessage({ id: 'createProjectWizard.step.allocation.selectSupervisors.title' })}
        </Typography>
        <Typography variant="body2" sx={{ color: 'error.main' }}>
          *
        </Typography>
      </Box>
      <Autocomplete
        multiple
        disabled={isSupervisorsLoading ?? false}
        options={supervisors}
        value={selectedSupervisors}
        disableCloseOnSelect
        getOptionLabel={(option) => option.label}
        inputValue={supervisorInputValue}
        onInputChange={(event, newInputValue, reason) => {
          if (reason === 'input') {
            lastTypedSupervisorValue.current = newInputValue;
            setSupervisorInputValue(newInputValue);
          }
        }}
        onChange={(event, newValue) => {
          // newValue = full selected array
          // sync with your state

          const added = newValue.filter((n) => !selectedSupervisors.some((s) => s.id === n.id));

          const removed = selectedSupervisors.filter((s) => !newValue.some((n) => n.id === s.id));

          added.forEach(handleAddSupervisor);
          removed.forEach(handleRemoveSupervisor);
        }}
        getOptionDisabled={(option) => selectedSupervisors.some((a) => a.id === option.id)}
        renderOption={(props, option, { selected }) => {
          const { key, ...otherProps } = props;

          return (
            <Box
              key={key}
              component="li"
              {...otherProps}
              sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
            >
              <Checkbox checked={selected} />

              <span>{option.label}</span>
            </Box>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={formatMessage({
              id: 'createProjectWizard.step.allocation.selectSupervisors.placeholder',
            })}
          />
        )}
      />
    </Box>
  );
};
